enum CurrencyCode {
  AUD = 'AUD',
  CAD = 'CAD',
  CNY = 'CNY',
  EUR = 'EUR',
  GBP = 'GBP',
  HKD = 'HKD',
  JPY = 'JPY',
  KRW = 'KRW',
  MXN = 'MXN',
  MYR = 'MYR',
  SGD = 'SGD',
  TWD = 'TWD',
  USD = 'USD',
}

export default CurrencyCode
